/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const ApiPrevmet = axios.create({ baseURL: 'https://apiprevmet3.inmet.gov.br' });

export default ApiPrevmet;
